import type { Components } from '@mui/material/styles';
import type { Theme } from '../types';

export const MuiAutocomplete = {
    styleOverrides: {
        paper: {
            // Using the default border from the input fiel and using for the dropdown options
            border: '1px solid rgba(var(--mui-palette-common-onBackgroundChannel) / 0.23)',
        },
    },
} satisfies Components<Theme>['MuiAutocomplete'];
